import React from 'react'

const PageNotFound = () => {
  return (
    <h2 className='text-center my-5'>404! Page Not Found</h2>
  )
}

export default PageNotFound